import { render, staticRenderFns } from "./ForumThreadFooter.vue?vue&type=template&id=98219256&"
import script from "./ForumThreadFooter.vue?vue&type=script&lang=js&"
export * from "./ForumThreadFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports